import React from 'react';
import {ErrorBoundaryFallback} from './ErrorBoundaryFallback'

export class ErrorBoundaryProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('error', error);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback/>;
    }

    return this.props.children; 
  }
}
